import adahPic from "@/public/images/artists/adah.jpg";
import { Artist } from "@/types/types";

export const adah = {
  id: "107",
  name: "Adah",
  image: adahPic,
  description: `Adah possesses a sweet, ethereal voice, perfectly suited for the vibrant rhythms of Afrobeat music. Her gentle yet captivating vocals have a mesmerizing quality that adds a unique touch to every melody, drawing audiences into a world of rhythmic euphoria and soulful serenity.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fadah-preview.mp3",

  meta: {
    free: false,
    new: false,
  },

  filters: {
    gender: "Female",
    tags: {
      primary: ["Afrobeat", "Ethereal"],
      secondary: ["Singer", "Alluring", "Organic", "Wide Range"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 57,
        high: 72,
      },
    },
  },
} as const satisfies Artist;
